import { Icon } from 'antd'
import { GlobalContext } from 'Global'
import React, { useState } from 'react'
import './dropdown.css'
import { Link } from 'react-router-dom'

function MenuItem({ text, icon = 'file-text', isActive, haveSub, to, isSub, setShow, show, isExternal }) {
  const activeStyle = isActive ? 'bg-gray-200 rounded-lg' : ''
  const { collapsed } = React.useContext(GlobalContext)

  const Item = () => (
    <>
      <span className="flex">
        <div className="h-8 w-8 fill-current text-gray-700">
          <Icon
            type={icon}
            style={{
              color: '#4a5568',
              fontSize: '20px',
              marginLeft: '2px',
            }}
          />
        </div>
        {!collapsed && <span className="ml-2 pt-1 text-gray-900">{text}</span>}
      </span>

      {haveSub && !collapsed && (
        <div
          className={`ml-2 fill-current h-4 w-4 transform ${
            show ? '-rotate-180' : ''
          } transition duration-150 ease-in-out`}>
          <Icon type="down" />
        </div>
      )}
    </>
  )

  const isSubStyle = isSub ? 'bg-gray-200 hover:bg-gray-300' : 'hover:bg-gray-200'
  const ItemStyle = `${isSubStyle} -mx-3 px-3 py-1 flex items-center justify-between  cursor-pointer text-sm font-medium ${activeStyle} hover:rounded-lg`

  return to ? (
    isExternal ? (
      <a href={to} onClick={setShow} className={ItemStyle}>
        <Item />
      </a>
    ) : (
      <Link to={to} onClick={setShow} className={ItemStyle}>
        <Item />
      </Link>
    )
  ) : (
    <div onClick={setShow} className={ItemStyle}>
      <Item />
    </div>
  )
}

function Dropdown({ title, icon, sub, to, divider, isExternal }) {
  const [show, setShow] = useState(false)
  const { scopes } = React.useContext(GlobalContext)

  return (
    <>
      {divider && <div className="my-1 h-1 border-b-2" />}
      <div className="group">
        <MenuItem
          key={title}
          text={title}
          icon={icon}
          haveSub={sub}
          show={show}
          to={sub ? null : to}
          isExternal={isExternal}
          setShow={() => setShow((e) => !e)}
        />

        {sub && (
          <div
            className={`${show ? 'scale-100 h-full' : 'scale-0 h-0'} transition duration-300 ease-in-out origin-top`}>
            {sub
              .filter((i) => scopes.includes(i.id))
              .map((i) => (
                <MenuItem
                  isExternal={isExternal}
                  key={`${to}${i.to}`}
                  text={i.text}
                  icon={i.icon}
                  to={`${to}${i.to}`}
                  isSub={true}
                />
              ))}
          </div>
        )}
      </div>
    </>
  )
}

export default Dropdown
